



// import React from 'react';
// import { motion } from 'framer-motion';
// import { Link } from 'react-router-dom';

// const HospitalLayout = () => {
//   const facilities = [
//     {
//       country: 'Guangzhou City',

//       locations: [
//         { name: 'ROYAL LEE CANCER HOSPITAL', image: 'assets/imgs/hospitals/royalee.jpg', link: '/medtrust-RoyaleeHospital' },
//         { name: 'GUANGZHOU BAIYUN MOUNTAIN HOSPITAL', image: 'assets/imgs/hospitals/guangzhou.png' },
//         { name: 'JINSHAZHOU HOSPITAL OF GUANGZHOU UNIVERSITY OF CHINESE MEDICINE', image: 'assets/imgs/hospitals/JINSHAZHOU.jpg' },
//         { name: 'GUANGZHOU UNITED FAMILY HOSPITAL', image: 'assets/imgs/hospitals/GUANGZHOU_UNITED.jpg' },
//         { name: 'GUANGZHOU FUDA CANCER HOSPITAL', image: 'assets/imgs/hospitals/fuda.jpg' }
//       ]
//     },
//     {
//       country: 'Foshan City',

//       locations: [
//         { name: 'HEYOU PINNACLE MEDICAL CENTER', image: 'assets/imgs/hospitals/heyou.png' },
//         { name: 'FOSHAN FOSUN CHANGCHENG HOSPITAL', image: 'assets/imgs/hospitals/fosan.jpg' }
//       ]
//     },
//     {
//       country: 'Shenzhen City',

//       locations: [
//         { name: 'SHENZHEN HENGSHENG HOSPITAL', image: 'assets/imgs/hospitals/SHENZHEN.jpg' },

//       ]
//     },
//     {
//       country: 'Shanghai City',

//       locations: [
//         { name: 'SHANGHAI DONGLEI BRAIN HOSPITAL', image: 'assets/imgs/hospitals/sanghai.jpg' },

//       ]
//     },

//   ];

//   const getGridClass = (count) => {
//     if (count === 1) return 'grid-cols-1 md:grid-cols-2';
//     if (count === 2) return 'grid-cols-1 md:grid-cols-2';
//     if (count === 3) return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3';
//     return 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4';
//   };

//   const getImageHeight = (count) => {

//     if (count === 2) return 'h-56';
//     return 'h-48';
//   };

//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.1
//       }
//     }
//   };

//   const itemVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         duration: 0.5
//       }
//     }
//   };


//   return (

//     <HospitalCards facilities={facilities} />
//   )

// };

// export default HospitalLayout;






// const HospitalCards = ({ facilities }) => {
//   return (
//     <div className="min-h-screen bg-white p-8">
//       <div className=" mx-auto">
//         <div className="text-center mb-12">
//           <h1 className="text-4xl md:text-5xl font-bold text-gray-800 my-4">Network of Top Hospitals</h1>
//           <p className="text-lg text-gray-600">We rigorously vet hospitals before adding to our panel, ensuring you receive the best care. We have in-depth knowledge of hospitals in every country we operate in.</p>
//         </div>

//         {facilities.map((facility, index) => (
          
//           <div key={index} className="mb-12">
//             <Link to={facilities.link} key={index}>
//               <h2 className="text-2xl font-bold text-gray-800 mb-6 pl-2 border-l-4 border-blue-500">
//                 {facility.country}
//               </h2>
//               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                 {facility.locations.map((location, locIndex) => (
//                   <div
//                     key={locIndex}
//                     className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
//                   >


//                     <div className="relative h-64 sm:h-72 md:h-80 lg:h-96 overflow-hidden">
//                       <img
//                         src={location.image}
//                         alt="Hospital facility"
//                         className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//                       />


//                       {/* Hospital name from bottom on hover */}
//                       <div className="absolute bottom-0 left-0 right-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out">
//                         <div className="successfull-experience backdrop-blur-md p-6 border-t border-white/20">
//                           <h3 className="text-sm md:text-lg font-bold text-white leading-tight">
//                             {location.name}
//                           </h3>
//                         </div>
//                       </div>
//                     </div>

//                   </div>
//                 ))}
//               </div>


//             </Link>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };




import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const HospitalLayout = () => {
  const facilities = [
    {
      country: 'Guangzhou City',
      locations: [
        {
          name: 'ROYAL LEE CANCER HOSPITAL',
          image: 'assets/imgs/hospitals/royalee.jpg',
          link: '/medtrust-RoyaleeHospital',
          city:'Guangzhou City'
        },
        {
          name: 'GUANGZHOU BAIYUN MOUNTAIN HOSPITAL',
          image: 'assets/imgs/hospitals/guangzhou.png',
          link: '/medtrust-RoyaleeHospital',
          city:'Guangzhou City'
        },
        {
          name: 'JINSHAZHOU HOSPITAL OF GUANGZHOU UNIVERSITY OF CHINESE MEDICINE',
          image: 'assets/imgs/hospitals/JINSHAZHOU.jpg',
          link: '/medtrust-RoyaleeHospital',
          city:'Guangzhou City'
        },
        {
          name: 'GUANGZHOU UNITED FAMILY HOSPITAL',
          image: 'assets/imgs/hospitals/GUANGZHOU_UNITED.jpg',
          link: '/medtrust-RoyaleeHospital',
          city:'Guangzhou City'
        },
        {
          name: 'GUANGZHOU FUDA CANCER HOSPITAL',
          image: 'assets/imgs/hospitals/fuda.jpg',
          link: '/medtrust-RoyaleeHospital',
          city:'Guangzhou City'
        }
      ]
    },
    {
      country: 'Foshan City',
      locations: [
        {
          name: 'HEYOU PINNACLE MEDICAL CENTER',
          image: 'assets/imgs/hospitals/heyou.png',
          link: '/medtrust-RoyaleeHospital',
          city:'Foshan City'
        },
        {
          name: 'FOSHAN FOSUN CHANGCHENG HOSPITAL',
          image: 'assets/imgs/hospitals/fosan.jpg',
          link: '/medtrust-RoyaleeHospital',
          city:'Foshan City'
        }
      ]
    },
    {
      country: 'Shenzhen City',
      locations: [
        {
          name: 'SHENZHEN HENGSHENG HOSPITAL',
          image: 'assets/imgs/hospitals/SHENZHEN.jpg',
          link: '/medtrust-RoyaleeHospital',
          city: 'Shenzhen City'
        }
      ]
    },
    {
      country: 'Shanghai City',
      locations: [
        {
          name: 'SHANGHAI DONGLEI BRAIN HOSPITAL',
          image: 'assets/imgs/hospitals/sanghai.jpg',
          link: '/medtrust-RoyaleeHospital',
          city: 'Shanghai City'
        }
      ]
    }
  ];

  return <HospitalCards facilities={facilities} />;
};

export default HospitalLayout;





/* ===========================
   Hospital Cards Component
=========================== */

const HospitalCards = ({ facilities }) => {
  return (
    <div className="min-h-screen bg-white p-8">
      <div className="mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-800 my-4">
            Network of Top Hospitals
          </h1>
          <p className="text-lg text-gray-600">
            We rigorously vet hospitals before adding to our panel, ensuring you receive the best care.
            We have in-depth knowledge of hospitals in every country we operate in.
          </p>
        </div>

        {facilities.map((facility, index) => (
          <div key={index} className="mb-12">

            {/* City Title */}
            <h2 className="text-2xl font-bold text-gray-800 mb-6 pl-2 border-l-4 border-blue-500">
              {facility.country}
            </h2>

            {/* Hospital Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

              {facility.locations.map((location, locIndex) => {

                const CardContent = (
                  <div className="group relative overflow-hidden rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer">

                    <div className="relative h-64 sm:h-72 md:h-80 lg:h-96 overflow-hidden">
                      <img
                        src={location.image}
                        alt={location.name}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                      />

                      {/* Hover Overlay */}
                      <div className="absolute bottom-0 left-0 right-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out">
                        <div className="backdrop-blur-md bg-black/50 p-6 border-t border-white/20">
                          <h3 className="text-sm md:text-lg font-bold text-white leading-tight">
                            {location.name}
                          </h3>
                        </div>
                      </div>
                    </div>

                  </div>
                );

                return location.link ? (
                  <Link to={location.link}
                  state={{ hospital: location }}
                   key={locIndex}>

                    {CardContent}
                  </Link>
                ) : (
                  <div key={locIndex}>
                    {CardContent}
                  </div>
                );
              })}

            </div>
          </div>
        ))}
      </div>
    </div>
  );
};



